import tokenService from "@/common/services/TokenService"
import type { Context, RouteRecord } from "@/common/types/router"
import type { IUser } from "@/common/types/user"

interface IProps {
    fallBackRoute: RouteRecord
    fetchUser: () => Promise<IUser>
}

const requireAuth = ({ fallBackRoute, fetchUser }: IProps) => {
    return async ({ next, nextMiddleware, useUser }: Context) => {
        const userStore = useUser()

        if (tokenService.jwt.has()) {
            try {
                if (userStore.getUser()?.id === undefined) {
                    userStore.setUser(await fetchUser())
                }

                return nextMiddleware()
            } catch (e) {
                /* empty */
            }
        }

        tokenService.removeTokens()
        userStore.setUser({})
        return next({ name: fallBackRoute.name })
    }
}

export default requireAuth
